import emailVerificationSuccessTranslation from './index.json';

export default emailVerificationSuccessTranslation;
